export const pageTitle = "OpenNeuro"
export const pageDescription =
  "A free and open platform for analyzing and sharing neuroimaging data"
